import { httpClient } from '../../../shared/api/httpClient';

export interface HudleStaffResult {
  ok?: boolean;
  sent?: boolean;
  email?: string;
  [key: string]: unknown;
}

const withTicket = (ticketId?: string, extra?: Record<string, unknown>) => ({
  ...(ticketId ? { ticketId } : {}),
  ...(extra || {}),
});

export async function resetHudlePassword(clientId: string, email?: string, ticketId?: string): Promise<HudleStaffResult> {
  return httpClient.post(`/tickets/clients/${clientId}/hudle/reset-password/`, withTicket(ticketId, email ? { email } : {}));
}

export async function disableHudleMfa(clientId: string, ticketId?: string): Promise<HudleStaffResult> {
  return httpClient.post(`/tickets/clients/${clientId}/hudle/disable-mfa/`, withTicket(ticketId));
}

export async function patchHudleProfile(
  clientId: string,
  data: { email?: string; username?: string; phone?: string; bio?: string; customStatus?: string },
  ticketId?: string
): Promise<HudleStaffResult> {
  return httpClient.patch(`/tickets/clients/${clientId}/hudle/profile/`, withTicket(ticketId, data));
}

export async function deleteHudleAvatar(clientId: string, ticketId?: string): Promise<HudleStaffResult> {
  return httpClient.post(`/tickets/clients/${clientId}/hudle/delete-avatar/`, withTicket(ticketId));
}

export async function banHudleUser(clientId: string, reason: string, ticketId?: string): Promise<HudleStaffResult> {
  return httpClient.post(`/tickets/clients/${clientId}/hudle/ban/`, withTicket(ticketId, { reason }));
}

export async function unbanHudleUser(clientId: string, ticketId?: string): Promise<HudleStaffResult> {
  return httpClient.post(`/tickets/clients/${clientId}/hudle/unban/`, withTicket(ticketId));
}
